import { render } from "./QuestionDisplay.vue?vue&type=template&id=7780a8cc&scoped=true"
import script from "./QuestionDisplay.vue?vue&type=script&lang=js"
export * from "./QuestionDisplay.vue?vue&type=script&lang=js"

import "./QuestionDisplay.vue?vue&type=style&index=0&id=7780a8cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7780a8cc"]])

export default __exports__